// extracted by mini-css-extract-plugin
export default {"poll":"dhsgPJpJY-poll","label":"dhsgnFHA4-label","question":"dhsgYyrHO-question","total":"dhsgs_EGq-total","result":"dhsgDgzE1-result","other":"dhsgMt8Qs-other"};